<x-chartist [data]="lineData" [type]="'Line'" [options]="lineOptions" class="height-300">
</x-chartist>